import Image from "next/image";
import ScreenshotWebPortal from "./images/web-portal.png";
import ScreenshotTrackingCase from "./images/track.png";
import ScreenshotNotifications from "./images/notifications.png";
import {
  FeatureCard,
  DescriptionCard,
  Descriptions,
  DescriptionTitle,
  Heading,
} from "./feature";
import { Feature } from "./feature";

export const Feature2 = () => {
  return (
    <Feature>
      <Heading>
        Never miss an important update
        <br
          css={`
            display: none;

            @media (min-width: 960px) {
              display: block;
            }
          `}
        />{" "}
        for your clients&apos; cases
      </Heading>

      <FeatureCard
        title="Automated Notification & Custom Web Portal"
        description="Receive important updates, including eligibility for case inquiry submissions and AOS filings, and share with applicants via a web portal"
        color="#EDE9FE"
        image={
          <Image
            src={ScreenshotWebPortal}
            alt="Screenshot Web Portal"
            width={1268}
            height={960}
            unoptimized={!!process.env.NEXT_PUBLIC_NETLIFY}
          />
        }
      />

      <Descriptions>
        <DescriptionCard>
          <div
            css={`
              height: 100%;
              display: flex;
              flex-direction: column;
            `}
          >
            <DescriptionTitle title="Track cases with real-time updates" />
            <div
              css={`
                display: flex;
                padding: 0 0 15px 0;

                @media (min-width: 960px) {
                  padding: 0;
                  flex: 1;
                  align-items: center;
                }
              `}
            >
              <Image
                src={ScreenshotTrackingCase}
                alt="Track Case"
                width={1280}
                height={386}
                unoptimized={!!process.env.NEXT_PUBLIC_NETLIFY}
              />
            </div>
          </div>
        </DescriptionCard>

        <DescriptionCard>
          <div
            css={`
              display: flex;
              flex-direction: column;
              gap: 20px;
            `}
          >
            <DescriptionTitle title="Receive critical notifications" />
            <div
              css={`
                display: flex;
                padding: 0 15px;

                @media (min-width: 960px) {
                  transform: translateX(80px);
                  padding: 0 30px;
                }
              `}
            >
              <Image
                src={ScreenshotNotifications}
                alt="Notifications"
                width={1068}
                height={783}
                unoptimized={!!process.env.NEXT_PUBLIC_NETLIFY}
              />
            </div>
          </div>
        </DescriptionCard>
      </Descriptions>
    </Feature>
  );
};
